import { users } from '@prisma/client';

export function isAdmin(user: users | undefined | null) {
  if (!user) return false;
  return user.is_admin;
}
